import { mapGetters } from 'vuex';
import searchSort from '@/msp/components/searchsort/search-sort.vue';

export default {
    name: 'searchList',
    inject: ['$eventBus'],
    components: {
        searchSort,
    },
    data() {
        return {
            componentMounted: false,
        };
    },
    computed: {
        ...mapGetters('msp', ['msp']),
        ...mapGetters('glb', ['viewport', 'glb', 'getSeoInfo', 'getSplit']),
        isList() {
            return this.msp.isListView;
        },
        fetchH1() {
            if (this.glb.webpush) {
                let text = 'Houses Matching Your Notification';
                if (this.msp.filter.propertyCriteriaOpenHouse) {
                    text = 'Open ' + text;
                }
                return text;
            }
            if (this.getSeoInfo.h1WithLink) {
                const forSalePath = this.glb.geo.geoPath.replace('rentals/', '');
                return this.getSeoInfo.h1.replace(
                    this.getSeoInfo.h1WithLink,
                    `<a class="hover-dotted" href="${this.glb.appUrl + forSalePath}" title="Homes for sale in ${this.getSeoInfo.h1WithLink}">${this.getSeoInfo.h1WithLink}</a>`
                );
            }
            return this.getSeoInfo.h1;
        },
        fetchH1Notification() {
            return this.getSeoInfo.h1;
        },
        notificationUrl() {
            return this.glb.appUrl + 'notification/';
        },
    },
    methods: {
        toggleView(flag) {

            if (window.innerWidth <= this.glb.viewport.smScreen[1]) {
                this.$eventBus.$emit('eventbus-showmap', false, true);
            } else {
                this.$eventBus.$emit('eventbus-showmap', true, true);
            }
            this.msp.isListView = flag;
            requestAnimationFrame(() => {
                let $searchHeader = document.querySelector('.search-header-stick');
                if ($searchHeader) {
                    $searchHeader.scrollIntoView({
                        block: 'center',
                    });
                }
            });
        },
    },
    mounted() {
        this.componentMounted = true;
    },
};
